import { render, staticRenderFns } from "./channels-list.vue?vue&type=template&id=07598079&scoped=true&"
import script from "./channels-list.vue?vue&type=script&lang=js&"
export * from "./channels-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07598079",
  null
  
)

export default component.exports